const consoleLogMobile = () => {
  if(process.env.REACT_APP_ENV ==='staging'){
    import('eruda').then(eruda => eruda.default.init());
  }
};

export default consoleLogMobile;
